
const isSupport = (data, i) => {
    let support = data[i].low < data[i - 1].low && data[i].low < data[i + 1].low &&
        data[i + 1].low < data[i + 2].low && data[i - 1].low < data[i - 2].low;

    return support;
}

const isResistance = (data, i) => {
    let resistance = data[i].high > data[i - 1].high && data[i].high > data[i + 1].high &&
        data[i + 1].high > data[i + 2].high && data[i - 1].high > data[i - 2].high;

    return resistance;
}

// const isFarFromLevel = (l, s, levels) => {
//     //return np.sum([abs(l-x) < s  for x in levels]) == 0
//     let sum = 0;
//     for (var i = 0; i < levels.length; i++) {
//         Math.abs(l - levels[i])
//     }
//     return Math.abs()
// }

const custom_sort = (a, b) => {
    return a - b;
}

const getAvg = (data) => {
    // Get average
    let total = 0;
    for (var j = 0; j < data.length; j++) {
        total += data[j];
    }
    let avg = total / data.length;
    return avg;
}

const nearBy = (percent, levels) => {
    let newLevels = [];
    let formGroup = [];
    for (var i = 0; i < levels.length - 1; i++) {
        let nearBy = levels[i + 1] < ((levels[i] * percent / 100) + levels[i]);
        //console.log('Support, resistance nearby ', levels[i + 1], ((levels[i] * percent / 100) + levels[i]), nearBy);
        if (nearBy) {
            formGroup.push(levels[i]);
        } else {
            newLevels.push(getAvg(formGroup));
            //console.log('Support, resistance formGroup', formGroup);
            formGroup = [];
        }
    }

    if (formGroup.length > 0) {
        newLevels.push(getAvg(formGroup));
    }
    return newLevels;
}

const withInPriceRange = (price, percent, levels) => {
    let newLevels = [];
    let startPrice = price - (price * percent / 100);
    let endPrice = price + (price * percent / 100);
    console.log('Support, resistance startPrice ', startPrice, endPrice);

    for (var i = 0; i < levels.length; i++) {
        if (levels[i] >= startPrice && levels[i] <= endPrice) {
            newLevels.push(levels[i]);
        }
    }
    return newLevels;
}


const getSupportResistance = (data) => {
    if (!(data !== undefined && data.length !== undefined && data.length > 0)) {
        return;
    }

    let levels = [];
    let lastPrice = data[data.length - 1].close;
    console.log('Support, resistance lastPrice', lastPrice);

    for (var i = 2; i < data.length - 2; i++) {
        if (isSupport(data, i)) {
            levels.push(data[i].low);
        } else if (isResistance(data, i)) {
            levels.push(data[i].high);
        }
    }
    //Sort
    levels.sort(custom_sort);

    console.log('Support, resistance', levels);
    let newLevels = nearBy(1, levels);

    //Cleanup
    newLevels = newLevels.filter(function (value) {
        return !Number.isNaN(value);
    });
    //newLevels.sort(custom_sort);
    //newLevels = newLevels.slice(Math.max(newLevels.length - 10, 0));
    // newLevels = newLevels.slice(0, 10);
    console.log('Support, resistance new levels ', newLevels);
    let filterLevels = withInPriceRange(lastPrice, 20, newLevels);

    filterLevels = filterLevels.slice(Math.max(filterLevels.length - 3, 0));
    // let filterLevels = newLevels.slice(0, 5);
    console.log('Support, resistance Last 5 levels ', filterLevels);
    return filterLevels;
}

export { getSupportResistance };